import styled, { keyframes } from 'styled-components';

export const CardWrapper = styled.div`
  width: 360px;
  min-width: 360px;
  height: fit-content;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.32);
  background-color: #fff;
  border-radius: 4px;
  padding: 10px;
`;

export const CardHeader = styled.div`
  position: relative;
`;

export const SelectTypeClaims = styled.select`
  vertical-align: top;
  display: inline-block;
  font-size: 14px;
  width: 183px;
  height: 48px;
  margin-right: 8px;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.colors.textLight};
  border-radius: 4px;
  padding: 0 25px 0 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
`;

export const SelectTypeClaimsIcon = styled.div`
  position: absolute;
  top: 21px;
  left: 160px;
  width: 14px;
  height: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L7 7L13 1' stroke='black'/%3E%3C/svg%3E%0A");
`;

export const CalendarRef = styled.div`
  vertical-align: top;
  display: inline-block;
`;

export const CalendarInput = styled.div`
  width: 146px;
  height: 48px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.textLight};
  border-radius: 4px;
  padding: 6px 11px;
  & span {
    display: block;
    width: 100%;
    text-align: left;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text};
  }
  & input {
    width: 100%;
    text-align: left;
    border: 0;
    background-color: #fff;
    cursor: pointer;
    font-size: 11px;
  }
`;

export const CalendarIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 13px;
  width: 15px;
  height: 17px;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 9H6V11H4V9ZM18 4V18C18 19.1 17.1 20 16 20H2C0.89 20 0 19.1 0 18L0.00999999 4C0.00999999 2.9 0.89 2 2 2H3V0H5V2H13V0H15V2H16C17.1 2 18 2.9 18 4ZM2 6H16V4H2V6ZM16 18V8H2V18H16ZM12 11H14V9H12V11ZM8 11H10V9H8V11Z' fill='%237871D1'/%3E%3C/svg%3E");
`;

export const CardTable = styled.div<{
  type: 'Total Estimado' | 'Total Indenizado';
}>`
  & div.card-header {
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: left;
    padding: 8px 6px;
    div {
      vertical-align: top;
      display: inline-block;
      text-align: left;
      color: ${({ theme }) => theme.colors.main};
      text-transform: uppercase;
      line-height: 32px;
    }
    div:nth-child(1) {
      width: 144px;
      padding-left: 7px;
    }
    div:nth-child(2) {
      width: 60px;
      margin-left: 10px;
      text-align: center;
    }
    div:nth-child(3) {
      border-radius: 4px;
      text-align: center;
      background-color: ${props =>
        props.type === 'Total Indenizado' ? '#0DAB01' : '#000f99'};
      width: 98px;
      line-height: 14px;
      color: #fff;
      padding: 3px;
      margin-left: 10px;
    }
  }
  & div.card-row-total {
    display: block;
    background-color: ${({ theme }) => theme.colors.main};
    border-radius: 8px;
    padding: 8px 6px;
    cursor: pointer;

    div {
      display: inline-block;
      line-height: 20px;
      vertical-align: top;
      padding: 10px 0;
    }
    div:nth-child(1) {
      width: 144px;
      font-size: 14px;
      font-weight: 700;
      text-align: left;
      color: #fff;
      text-transform: uppercase;
      padding-left: 7px;
    }
    div:nth-child(2) {
      width: 60px;
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      background-color: #fff;
      border-radius: 20px;
      color: ${({ theme }) => theme.colors.main};
      margin-left: 10px;
    }
    div:nth-child(3) {
      width: 98px;
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      background-color: #fff;
      border-radius: 20px;
      color: ${({ theme }) => theme.colors.main};
      margin-left: 10px;
    }
  }
  & div.card-row {
    display: block;
    padding: 8px 6px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
    align-items: center;
    justify-content: center;
    display: flex;
    cursor: pointer;
    &:last-child {
      border-bottom: 0px;
    }
    div {
      display: inline-block;
      line-height: 18px;
      vertical-align: top;
      color: #000;
      padding: 10px 0;
    }
    div:nth-child(1) {
      width: 144px;
      padding-left: 18px;
      font-size: 13px;
      text-align: left;
      padding-left: 7px;
    }
    div:nth-child(2) {
      width: 60px;
      font-size: 14px;
      text-align: center;
      background-color: ${({ theme }) => theme.colors.background};
      border-radius: 20px;
      margin-left: 10px;
    }
    div:nth-child(3) {
      width: 98px;
      font-size: 14px;
      text-align: center;
      background-color: ${({ theme }) => theme.colors.background};
      border-radius: 20px;
      margin-left: 10px;
    }
  }
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
export const Loading = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  background-image: conic-gradient(
    from 180deg at 50% 50%,
    #fff 0deg,
    ${({ theme }) => theme.colors.main} 360deg
  );
  width: 60px;
  height: 60px;
  border-radius: 100%;
  position: relative;
  margin: 30px auto;
  &:after {
    content: '';
    background-color: #fff;
    position: absolute;
    top: 9px;
    left: 9px;
    width: 42px;
    height: 42px;
    border-radius: 100%;
  }
`;
